import { render } from "./CheckStorageAndBag.vue?vue&type=template&id=a396e6e8&scoped=true"
import script from "./CheckStorageAndBag.vue?vue&type=script&lang=js"
export * from "./CheckStorageAndBag.vue?vue&type=script&lang=js"

import "./CheckStorageAndBag.vue?vue&type=style&index=0&id=a396e6e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a396e6e8"]])

export default __exports__